/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-08-21 10:14:22
 * @LastEditors: wl
 * @LastEditTime: 2020-08-21 10:29:25
 */
import axios from '../axios'
// /admin/service/sys_employment_list
//后台社区再就业 列表
export const handleQuery = (data) => {
    return axios({
        url: '/admin/service/sys_employment_list',
        method: 'post',
        data
    })
}
// 
export const handleSave = (data) => {
    return axios({
        url: '/admin/service/sys_employment_save',
        method: 'post',
        data
    })
}

//sys_employment_del
//社区再就业 删除

export const batchDeleteType = (data) => {
    return axios({
        url: '/admin/service/sys_employment_del',
        method: 'post',
        data
    })
}

//疑似迁出
export const suspected = (data) => {
    return axios({
        url: '/admin/service/sys_suspected_relocation',
        method: 'post',
        data
    })
}


// 已读
export const relocationread = (data) => {
    return axios({
        url: '/admin/service/suspected_relocation_read',
        method: 'post',
        data
    })
}
//迁出
export const relocationmove = (data) => {
    return axios({
        url: '/admin/service/suspected_relocation_move',
        method: 'post',
        data
    })
}

//嘉陵网格列表
export const jialing_wangge_list = (data) => {
    return axios({
        url: '/admin/service/jialing_wangge_list',
        method: 'post',
        data
    })
}
//嘉陵网格添加
export const jialing_wangge_add = (data) => {
    return axios({
        url: '/admin/service/jialing_wangge_add',
        method: 'post',
        data
    })
}
//AIE
export const getAie = (data) => {
    return axios({
        url: '/agent_cross_domain',
        method: 'post',
        data,
        type:3
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/wxJob.js